import { render, staticRenderFns } from "./PanelMobileShimmer.vue?vue&type=template&id=63ed3ea8&"
import script from "./PanelMobileShimmer.vue?vue&type=script&lang=js&"
export * from "./PanelMobileShimmer.vue?vue&type=script&lang=js&"
import style0 from "./PanelMobileShimmer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports